/**
 * Cihaz kimliği yardımcıları.
 * device_id: localStorage'de saklanan kalıcı UUID.
 * user_agent: tarayıcı bilgisi (backend cihaz adını tahmin etmek için).
 * device_name: kullanıcı isterse verebilir (opsiyonel).
 */

const DEVICE_KEY = "st_device_id";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    // localStorage yoksa in-memory ID döndür (her sayfa yenilemede yeni)
    return uuid();
  }
}

export function getUserAgent() {
  try { return navigator.userAgent || ""; } catch { return ""; }
}

export function guessDeviceName() {
  const ua = getUserAgent().toLowerCase();
  if (ua.includes("iphone")) return "iPhone";
  if (ua.includes("ipad")) return "iPad";
  if (ua.includes("android")) return "Android";
  if (ua.includes("mac")) return "Mac";
  if (ua.includes("windows")) return "Windows PC";
  if (ua.includes("linux")) return "Linux";
  return "";
}
